import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import RunJobCandidateList from "@pages/job/runjob/RunJobCandidateList";
import JobPipeLineList from "@pages/jobpipeline/list/JobPipeLineList";
import {PipelineListMode} from "@pages/job/runjob/RunJobListTable";

export const RunJobParentTabs = [
    {title: '1 - PRE-EMAIL', id: 'pre-email-tab'},
    {title: "2 - GỬI EMAIL", id: 'email-tab'},
    {title: '3 - Follow up USER-CDDs DISCUSSION', id: 'follow-up-user-cdd-discussion-tab'},
    {title: '4 - Follow up USER-REFERERs DISCUSSION', id: 'follow-up-user-referer-discussion-tab'},
    {title: "5 - Contact PERSON CHƯA CÓ EMAIL", id: 'contact-person-not-email-tab'},
    {title: "6 - Contact PERSON FIT emailed, chưa phản hồi", id: 'contact-person-fit-email-not-feedback-tab'},
    {title: "7 - PROCESS CDD TO EMP", id: 'process-cdd-to-emp-tab'},
    {title: "8 - THANH TOÁN & BẢO HÀNH", id: 'payment-guarantee-tab'}
]

export const RunJobParentTabIds = {
    PRE_EMAIL: 'pre-email-tab',
    EMAIL_TAB: 'email-tab',
    FOLLOW_UP_USER_CDD_DISCUSSION: 'follow-up-user-cdd-discussion-tab',
    FOLLOW_UP_USER_REFERER_DISCUSSION: 'follow-up-user-referer-discussion-tab',
    CONTACT_PERSON_NOT_EMAIL: 'contact-person-not-email-tab',
    CONTACT_PERSON_FIT_EMAIL_NOT_FEEDBACK: 'contact-person-fit-email-not-feedback-tab',
    PROCESS_CDD_TO_EMP: 'process-cdd-to-emp-tab',
    PAYMENT_GUARANTEE: 'payment-guarantee-tab',
}

export const SendEmailInviteJobTabs = [
    {title: '2.1-Duyệt Draft', id: 'draft-tab'},
    {title: "2.2-UV bạn chưa có quyền gửi email", id: 'not-permission-email-tab'},
    {title: '2.3-UV need checking', id: 'need-checking-tab'},
    {title: "2.4-UV cần nhập bổ sung ttin", id: 'need-input-info-tab'},
    {title: "2.5-UV chờ gửi theo tuần", id: 'send-every-week-tab'},
    {title: "2.6-UV chờ hạn mức", id: 'send-when-unlimited-tab'},
    {title: "2.7 - UV đã export, chờ NL Gửi email mời job", id: 'exported-waiting-send-email-tab'}
]

export const SendEmailInviteJobTabIds = {
    NOT_PERMISSION_EMAIL: 'not-permission-email-tab',
    NEED_CHECKING: 'need-checking-tab',
    NEED_INPUT_INFO: 'need-input-info-tab',
    APPROVE_DRAFT: 'draft-tab',
    SEND_EVERY_WEEK: 'send-every-week-tab',
    SEND_WHEN_UNLIMITED: 'send-when-unlimited-tab',
    EXPORTED_WAITING_SEND_EMAIL: 'exported-waiting-send-email-tab'
}

export const PreEmailTabs = [
    {title: 'BOOKED > to Email', id: 'booked-to-email-tab'},
    {title: 'TARGETED > to Book, Email', id: 'targeted-to-book-email-tab'},
    {title: 'Available to RE-BOOK / RE-EMAIL', id: 'available-to-rebook-reemail-tab'},
    {title: 'UV có EMAIL MỚI', id: 'uv-has-new-email-tab'},
]

export const PreEmailTabIds = {
    BOOKED_TO_EMAIL: 'booked-to-email-tab',
    TARGETED_TO_BOOK_EMAIL: 'targeted-to-book-email-tab',
    AVAILABLE_TO_REBOOK_REEMAIL: 'available-to-rebook-reemail-tab',
    UV_HAS_NEW_EMAIL: 'uv-has-new-email-tab',
}

export const FollowUpUserCddDiscussionTabs = [
    {title: 'Chưa phân loại', id: 'not-category-tab'},
    {title: 'To send', id: 'to-send-tab'},
    {title: 'Apply', id: 'apply-tab'},
    {title: 'Quan tâm', id: 'take-care-tab'},
    {title: 'Chờ UV', id: 'waiting-uv-tab'},
    {title: 'Từ chối', id: 'reject-tab'},
    {title: 'Others', id: 'others-tab'},
]

export const FollowUpUserCddDiscussionTabIds = {
    NOT_CATEGORY: 'not-category-tab',
    TO_SEND: 'to-send-tab',
    APPLY: 'apply-tab',
    WAITING_UV: 'waiting-uv-tab',
    REJECT: 'reject-tab',
    OTHERS: 'others-tab',
}

export const FollowUpUserReferDiscussionTabs = [
    {title: 'Refer có Email', id: 'refer-has-email-tab'},
    {title: 'Refer có SĐT, chưa có email', id: 'refer-has-phone-not-email-tab'},
    {title: 'Refer chưa có cả SĐT & email', id: 'refer-not-phone-not-email-tab'},
    {title: 'Nói sẽ refer / Hỏi thtin', id: 'say-will-refer-ask-info-tab'},
    {title: 'Others', id: 'others-tab'},
]

export const FollowUpUserReferDiscussionTabIds = {
    REFER_HAS_EMAIL: 'refer-has-email-tab',
    REFER_HAS_PHONE_NOT_EMAIL: 'refer-has-phone-not-email-tab',
    REFER_NOT_PHONE_NOT_EMAIL: 'refer-not-phone-not-email-tab',
    SAY_WILL_REFER_ASK_INFO: 'waiting-uv-tab',
    OTHERS: 'others-tab',
}

export const ContactPersonNotEmailTabs = [
    {title: 'Referee', id: 'referee-tab'},
    {title: 'UV / Referer fit', id: 'uv-referer-fit-tab'},
    {title: 'Other Booked/Targeted', id: 'other-booked-targeted-tab'},
    {title: 'UV/Referer fit - Chưa có cả SĐT và email', id: 'uv-referer-fit-not-phone-not-email-tab'}
]

export const ContactPersonNotEmailTabIds = {
    REFEREE_TAB: 'referee-tab',
    UV_REFERER_FIT: 'uv-referer-fit-tab',
    OTHER_BOOKED_TARGETED: 'other-booked-targeted-tab',
    UV_REFERER_FIT_NOT_PHONE_NOT_EMAIL: 'uv-referer-fit-not-phone-not-email-tab',
    OTHERS: 'others-tab',
}

export const ContactPersonFitEmailNotFeedbackTabs = [
    {title: 'UV fit', id: 'uv-fit-tab'},
    {title: 'Referer fit', id: 'referer-fit-tab'},
]

export const ProcessCddToEmpTabs = [
    {title: 'CẦN SEND', id: 'need-send-tab'},
    {title: 'ĐÃ SEND', id: 'sent-tab'},
]

export const PaymentGuaranteeTabs = [
    {title: 'Dữ liệu', id: 'data-tab'},
]

const RunJobParentTabContent = (props) => {
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    const [childTabList, setChildTabList] = useState([]);
    const [runJobInfo, setRunJobInfo] = useState({});
    const [mailTabData, setMailTabData] = useState({});

    const {runJob, parentTab} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const onTabClicked = async (tab) => {
        setCurrentTab({...tab});
    };

    const activeTab = (tab) => {
        if (currentTab.id === tab.id) {
            return 'active'
        }
        return ''
    }

    const setTabContents = (pTab) => {
        let currTab = {...SendEmailInviteJobTabs[0]}
        let childTabs = [...SendEmailInviteJobTabs]
        if (pTab.id === RunJobParentTabIds.PRE_EMAIL) {
            currTab = {...PreEmailTabs[0]}
            childTabs = [...PreEmailTabs]
        } else if (pTab.id === RunJobParentTabIds.FOLLOW_UP_USER_CDD_DISCUSSION) {
            currTab = {...FollowUpUserCddDiscussionTabs[0]}
            childTabs = [...FollowUpUserCddDiscussionTabs]
        } else if (pTab.id === RunJobParentTabIds.FOLLOW_UP_USER_REFERER_DISCUSSION) {
            currTab = {...FollowUpUserReferDiscussionTabs[0]}
            childTabs = [...FollowUpUserReferDiscussionTabs]
        } else if (pTab.id === RunJobParentTabIds.CONTACT_PERSON_NOT_EMAIL) {
            currTab = {...ContactPersonNotEmailTabs[0]}
            childTabs = [...ContactPersonNotEmailTabs]
        } else if (pTab.id === RunJobParentTabIds.CONTACT_PERSON_FIT_EMAIL_NOT_FEEDBACK) {
            currTab = {...ContactPersonFitEmailNotFeedbackTabs[0]}
            childTabs = [...ContactPersonFitEmailNotFeedbackTabs]
        } else if (pTab.id === RunJobParentTabIds.PROCESS_CDD_TO_EMP) {
            currTab = {...ProcessCddToEmpTabs[0]}
            childTabs = [...ProcessCddToEmpTabs]
        } else if (pTab.id === RunJobParentTabIds.PAYMENT_GUARANTEE) {
            currTab = {...PaymentGuaranteeTabs[0]}
            childTabs = [...PaymentGuaranteeTabs]
        }

        setParentOfTab(pTab)
        setCurrentTab(currTab)
        setChildTabList(childTabs)
    }

    useEffect(() => {
        if (parentTab) {
            setTabContents(parentTab)
        }
        if (runJob) {
            setRunJobInfo(runJob)
        }
    }, [runJob, parentTab]);

    return (
        <>
            <div className="container-fluid">
                <div className="card card-default mt-3">
                    <div className="card-header">
                        <h3 className="card-title"><b>{parentOfTab.title}</b></h3>
                    </div>

                    <div className="card-body p-0">
                    <ul className='nav nav-tabs' role='tablist'>
                        {childTabList.map(tab => (
                            <li className='nav-item' key={`saved-list-tab-item-${tab.id}`}>
                                <a className={`nav-link ${activeTab(tab)}`} data-toggle='tab' href={`#${tab.id}`}
                                   onClick={() => onTabClicked(tab)}>{tab.title} ({mailTabData[tab.id] ? mailTabData[tab.id] : 0})</a>
                            </li>
                        ))}
                    </ul>
                    <div className='tab-content'>
                        {childTabList.map((tab, index) => {
                            if (currentTab.id === tab.id) {
                                if (parentOfTab.id === RunJobParentTabIds.PRE_EMAIL
                                    || parentOfTab.id === RunJobParentTabIds.EMAIL_TAB
                                ) {
                                    return <div id={tab.id} className={`tab-pane ${activeTab(tab)}`}
                                                style={{height: '83vh', overflow: 'auto'}} key={`run-job-sub-tab-content-${parentTab.id}-${tab.id}`}>
                                        <RunJobCandidateList runJob={runJobInfo} parentTab={parentOfTab} subTab={currentTab}/>
                                    </div>
                                }

                                if (parentOfTab.id === RunJobParentTabIds.FOLLOW_UP_USER_CDD_DISCUSSION
                                    || parentOfTab.id === RunJobParentTabIds.FOLLOW_UP_USER_REFERER_DISCUSSION
                                    || parentOfTab.id === RunJobParentTabIds.CONTACT_PERSON_NOT_EMAIL
                                    || parentOfTab.id === RunJobParentTabIds.CONTACT_PERSON_FIT_EMAIL_NOT_FEEDBACK
                                    || parentOfTab.id === RunJobParentTabIds.PROCESS_CDD_TO_EMP
                                    || parentOfTab.id === RunJobParentTabIds.PAYMENT_GUARANTEE) {
                                    return <JobPipeLineList jobId={runJobInfo.job_id} runJobMode
                                                            runJob={runJobInfo}
                                                            pTab={parentOfTab} sTab={currentTab}/>
                                }
                            }
                            return "";
                        })}
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}

export default RunJobParentTabContent;
